import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface DriverSeatProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function DriverSeat(props: DriverSeatProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Driver Seat"
      width={224}
      height={144}
      viewBox="0 0 224 144"
      position={{bottom: 72, left: 555}}
    >
      <path
        d="M223 108.758C223 136.574 178.317 141.057 161.443 134.103L161 134.067C155.077 139.132 130.069 149.387 109.684 137.433L109 137.001C101.458 140.563 79.4317 143 54.6598 143C4.84678 143 1 107.001 1 88.0005V72.0005V56C1 37 4.84678 1.00006 54.6598 1.00006C79.4317 1.00006 101.458 3.43775 109 7L109.684 6.5678C130.069 -5.386 155.077 4.86892 161 9.93368L161.443 9.89791C178.317 2.94376 223 7.42619 223 35.2426V72.0005V108.758Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M161 9.93368C155.077 4.86892 130.069 -5.38599 109.684 6.56781C106.229 8.5937 108.697 18.4339 111.658 22.7751C114.619 27.1164 121.529 32.3988 126.958 34.4247C132.387 36.4506 162 35.9436 162 35.9436"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 18.0003C21 26.0003 30 34.0003 55 34.0003C80.6 34.0003 82 34.0003 84 34.0003C91 34.0003 109 32 112 23"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 10C170 12 181 14.4921 181 24C181 33.5079 181 36.9999 181 40"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 39C210 35.9999 210 35.5079 210 26C210 13.8774 195 9 195 9"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 64.6332C167.862 61.8178 172.679 53.684 189.984 53.684C198.956 53.684 204.4 53.684 208.646 53.684C212.893 53.684 215.997 57.2878 215.997 60.0127"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 90.0004V72.0004V54.0002C165 49.0002 171.295 39.0002 191 39.0002H204C208 39.0002 216 39.0002 216 45.0001V72.0004V99.0004C216 105 208 105 204 105H191C171.295 105 165 95.0004 165 90.0004Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M51 110L46 105C44 103 43 101 43 98V72V46.0004C43 43 44 41 46 39L51 34"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 134.067C155.077 139.132 130.069 149.387 109.684 137.433C106.229 135.407 108.697 125.567 111.658 121.225C114.619 116.884 121.529 111.602 126.958 109.576C132.387 107.55 162 108.057 162 108.057"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 126C21 118 30 110 55 110C80.6 110 82 110 84 110C91 110 109 112.001 112 121.001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 134.001C170 132.001 181 129.508 181 120.001C181 110.493 181 107.001 181 104.001"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 105.001C210 108.001 210 108.493 210 118.001C210 130.123 195 135.001 195 135.001"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M109 137.001C101.458 140.563 79.4317 143 54.6598 143C4.84678 143 1 107.001 1 88.0005V72.0005V56C1 37 4.84678 1.00006 54.6598 1.00006C79.4317 1.00006 101.458 3.43775 109 7"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M168.993 97.3847C164.074 100.561 154.495 123.175 161.443 134.103C178.317 141.057 223 136.574 223 108.758C223 87.2996 223 75.3121 223 72.0005C223 68.689 223 56.701 223 35.2426C223 7.42619 178.317 2.94376 161.443 9.89791C154.495 20.8259 164.074 43.4398 168.993 46.6159"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M130 109.001C128 108.001 124 105.01 124 102.001C124 98.8005 124 72 124 72C124 72 124 45.2 124 42C124 38.9906 128 36 130 35"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 79.3676C167.862 82.183 172.679 90.3168 189.984 90.3168C198.956 90.3168 204.4 90.3168 208.646 90.3168C212.893 90.3168 215.997 86.713 215.997 83.988"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 72.0005H43"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
